import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import Env from './util/env'
// import registerServiceWorker from './registerServiceWorker';


Env.requestUserInfo(function () {
  ReactDOM.render(<App />, document.getElementById('root'))
})
// registerServiceWorker();
